import { render, staticRenderFns } from "./sl-list.vue?vue&type=template&id=952d8648&"
import script from "./sl-list.vue?vue&type=script&lang=js&"
export * from "./sl-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports